import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../redux/axios';

const initialState = {
    allProcessData: [],
    processTimeLogs: [],
    signed: [],
    concurrentDoc: [],
    isFetching: false,
    isAllprocessSuccess: false,
    isError: false,
    errorMessage: '',
    docPathname: '',
};

export const getViewAllProcess = createAsyncThunk(
    '/chd/viewDetailedProcess?processId',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            let response = await axios({
                url: `/api/chd/viewDetailedProcess?processId=${udata}`,
                method: 'get',
                headers: {
                    "Authorization": `Bearer ${tokenStr}`
                }
            })

            let data = response.data;
            if (response.status === 200) {
                return data;
            }
            else if (data.code === 200) {
                return data;
            }
            else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(err.response.data)
        }
    }
);




export const ChdViewProcessSlice = createSlice({
    name: 'chdviewprocess',
    initialState,
    reducers: {
        clearStateChdViewProcess: (state, { payload }) => {
            state.allProcessData = [];
            state.processTimeLogs = [];
            state.signed = [];
            state.concurrentDoc = [];
            state.isFetching = false;
            state.isAllprocessSuccess = false;
            state.isError = false;
            state.errorMessage = '';
            state.docPathname = '';
        },
    },

    extraReducers: {
        [getViewAllProcess.fulfilled]: (state, { payload }) => {
            state.allProcessData = payload.data.data;
            state.concurrentDoc = payload.data.concurrentDoc;
            state.processTimeLogs = payload.data.data.processTimeLogs;
            state.signed = payload.data.data.signed;
            state.docPathname = payload.data.path;
            state.isFetching = false;
            state.isAllprocessSuccess = true;
            return state;
        },
        [getViewAllProcess.pending]: (state) => {
            state.isFetching = true;
        },
        [getViewAllProcess.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        }
    },
});

export const { clearStateChdViewProcess } = ChdViewProcessSlice.actions;

export function clearState() {

    return async (dispatch) => {
        dispatch(clearStateChdViewProcess());
    }
}


export const takeActionAsyn = (pdata) => async (dispatch, getState) => {
    try {
        const { auth } = getState()
        let tokenStr = auth.user.token;
        let response = await axios({
            url: `/api/chd/document/detailed?processId=${pdata}`,
            method: 'get',
            //timeout: 8000,
            headers: {
                //'Content-Type': 'application/json',
                "Authorization": `Bearer ${tokenStr}`
            }
        })

        let data = response.data;
        return data;
        // console.log(data.data)
        //dispatch(getAllUserDepartments(data));
    } catch (error) {
        return error.response.data;
    }
};



export const takeActionChildProcessAsyn = (pdata) => async (dispatch, getState) => {
    try {
        const { auth } = getState()
        let tokenStr = auth.user.token;
        let userType = auth.user.userType == 'CHD' ? 'chd' : auth.user.userType == "DD's & AD's" ? 'DDsAndAds' : 'clerk';
        let response = await axios({
            url: `/api/${userType}/v2/document/detailed?processId=${pdata}`,
            method: 'get',
            headers: {
                "Authorization": `Bearer ${tokenStr}`
            }
        })

        let data = response.data;
        return data;
    } catch (error) {
        return error.response.data;
    }
};

export const getDcryptedPDF = (pdata) => async (dispatch, getState) => {
    try {
        const { auth } = getState()
        let tokenStr = auth.user.token;
        let userType = auth.user.userType == 'CHD' ? 'chd' : auth.user.userType == "DD's & AD's" ? 'DDsAndAds' : 'clerk';
        let response = await axios({
            url: `/api/clerk/givePdf?pdfName=${pdata}`,
            method: 'get',
            headers: {
                "Authorization": `Bearer ${tokenStr}`
            }
        })

        let data = response.data;
        return data;
    } catch (error) {
        return error.response.data;
    }
};

export const EncrptyPdfDataDelAsyn = (bdata) => async (dispatch, getState) => {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    let userType = auth.user.userType == 'CHD' ? '/chd' : auth.user.userType == "DD's & AD's" ? '/DDsAndAds' : auth.user.userType == "Clerk" ? '/clerk' : "";
    let response = await axios({
        url: `/api/clerk/removePdf?pdfName=${bdata}`,
        method: 'delete',
        headers: {
            "Authorization": `Bearer ${tokenStr}`
        }
    })
    let data = response.data;
    return data;
};


export const ChdViewProcessSelector = (state) => state.chdviewprocess;

export default ChdViewProcessSlice.reducer;
